import { useEffect, useState } from "react";
import {
    ListContainer,
    ListContext,

    Page,
    PageRoute,
    SearchBar,
    buildTemplatePath,
} from "@compass/core";

import { ListFooter } from "components";
import { ListFilterBase, Permission, PostHSPlanStatusListResource, SimpleDto } from "generated/openApi";
import { useInitListFilter, useList } from "hooks";
import { Outlet } from "react-router-dom";
import ApiService from "services/apiService";
import { PostHSPlanStatusListPageHeader } from "./PostHSPlanStatusListPageHeader";
import { PostHSPlanStatusTable } from "./PostHSPlanStatusTable";

const routeName = "postHSPlanStatus";

export const postHSPlanStatusListPageRoute: PageRoute = {
    handle: "Post-HS Status",
    templatePath: buildTemplatePath(routeName),
    getPath: () => buildTemplatePath(routeName),
};

export const PostHSPlanStatusListPage = () => {
    const ROOT_PERMISSION = Permission.MatchUtility;

    const [listItems, setListItems] = useState<SimpleDto[]>([]);

    const { listFilter, setListFilter } = useInitListFilter<ListFilterBase>({
        sortObjects: [{ property: "name", isDesc: false }],
    });

    const [total, setTotal] = useState<number>();
    const [resource, setResource] = useState<PostHSPlanStatusListResource | null>(null);
    const [searchFocused, setSearchFocused] = useState<boolean>(false);

    const { tableContainerRef, applyPage, applyPageSize, loadList, applySort, applySearch, applySortMethod } = useList({
        listFilter,
        setListFilter,
        fetchList: async (listFilter) => {
            const data = await ApiService.postHSPlanStatus.getList();
            setListItems(data || []);
        },
        fetchTotal: async (listFilter) => {
            const data = await ApiService.postHSPlanStatus.getList();
            setTotal(data?.length || 0);
        },
    });

    useEffect(() => {
        loadList(listFilter);
        ApiService.postHSPlanStatus.getListResource()
            .then(setResource)
            .catch((err) => {
                console.error("Failed to fetch list resource", err);
            });
    }, []);

    return (
        <Page header={<PostHSPlanStatusListPageHeader rootPermission={ROOT_PERMISSION} handle={postHSPlanStatusListPageRoute.handle} />}>
            <ListContainer
                fullHeight
                header={<SearchBar onStoppedTyping={applySearch} setSearchFocused={setSearchFocused} size="small" />}
                tableContainer={
                    resource && (
                        <PostHSPlanStatusTable
                            rootPermission={ROOT_PERMISSION}
                            tableContainerRef={tableContainerRef}
                            postHSPlanStatuss={listItems}
                            setPostHSPlanStatuss={setListItems}
                            resource={resource}
                            searchFocused={searchFocused}
                            sortObjects={listFilter.sortObjects}
                            sort={applySort}
                            loadList={() => loadList(listFilter)}
                        />
                    )
                }
                footer={
                    <ListFooter
                        total={total}
                        size={listFilter.pageSize}
                        page={listFilter.page}
                        onPageChange={applyPage}
                        onSizeChange={applyPageSize}
                        onSortMethodChange={applySortMethod}
                    />
                }
            />
            <ListContext.Provider
                value={{
                    loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }),
                }}
            >
                <Outlet />
            </ListContext.Provider>
        </Page>
    );
};